/*eslint-disable */
const $ = window.jQuery = require('jquery');

import 'vue-datetime/dist/vue-datetime.css'

import { Datetime } from 'vue-datetime';
import { VueEditor } from "vue2-editor";
import toast from '@/services/toast';

export default {
  name: 'update-event-data-screen',
  components: {
    VueEditor,
    Datetime
  },
  props: [],
  data () {
    return {
      submitted:false,
      title:'',
      email:'',
      banner:null,
      bannerName:'',
      thumbnail:null,
      thumbnailName:'',
      description:'',
      uploadImgSize: false,
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold', 'italic', 'link', '|', 'heading', 'fontFamily', 'fontSize', 'undo', 'redo']
      },
      editorData: '',
      minDatetime:new Date().toISOString(),
      datetime:'',
      host:'',
      pdfFile:null,
      pdfFileName:''
    }
  },
  computed: {
  },
  mounted(){
    this.$store.dispatch('getEventInfoByIdAction', {id:this.$route.params.eventId}).then((res) => {
      this.title = res.data.data.title
      this.description = res.data.data.description
      this.host = res.data.data.host
      this.datetime = res.data.data.datetime
      this.bannerName = res.data.data.banner.split('/')[5].split('?')[0]
      this.thumbnailName = res.data.data.thumbnail.split('/')[5].split('?')[0]
      if(res.data.data.pdf){
        this.pdfFileName = res.data.data.pdf.split('/')[5].split('?')[0]
      }
    })
  },
  methods: {
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          var formData = new FormData();
          formData.append('title', this.title);
          if(this.banner){
            formData.append('banner', this.banner);
          }
          if(this.thumbnail){
            formData.append('thumbnail', this.thumbnail);
          }
          if(this.host){
            formData.append('host', this.host);
          }
          if(this.pdfFile){
            formData.append('pdf', this.pdfFile);
          }
          formData.append('datetime', this.datetime);
          formData.append('description', this.description);
          this.$store.dispatch('updateEventInfoAction', {data:{id:this.$route.params.eventId, data:formData}})
            .then((res) => {  
                this.submitted = false;
                toast.success(res.data.msg || "Request has been successfully submitted");            
                this.$router.push({ name: 'adminEvent'})
            }).catch((err) => {
                this.submitted = false;
                toast.error(err.data.user_msg || err.data.msg);
            })
            return;
        }
      });
    },
    // GET THE IMAGE WIDTH AND HEIGHT USING fileReader() API.
    readImageFile(file) {
      var __self = this
      var reader = new FileReader(); // CREATE AN NEW INSTANCE.
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        img.onload = function () {
          var w = this.width;
          var h = this.height;
          if (w > 980 && h > 300) {
            __self.uploadImgSize = true
          } else {
            __self.uploadImgSize = false
          }
        }
      };
      reader.readAsDataURL(file);
    },
    clearUploadedBannerMethod(){
      let field = document.getElementById('bannerFile');
      field.value = null
      this.$refs.bannerFile = null
      this.banner = null
      this.bannerName = ''
      this.$validator.reset()
    },
    handleBannerUploadMethod(event) {
      if(event.target.files && event.target.files.length > 0) {
        this.readImageFile(event.target.files[0])
        setTimeout(() => {
          if (this.uploadImgSize) {
            this.banner = event.target.files[0];
            const files = this.$refs.bannerFile.files[0];
            this.bannerName = files.name
          } else {
            alert("The Height And Width Must Be Greater Than 1200px * 150px")
          }
        },100)
      }
    },
    clearUploadedThumbnailMethod(){
      this.thumbnail = null
      this.thumbnailName = ''
      this.$validator.reset();
    },
    handleThumbnailUploadMethod(event) {
      if(event.target.files && event.target.files.length > 0) {
        this.thumbnail = event.target.files[0];
        const files = this.$refs.thumbnailFile.files[0];
        this.thumbnailName = files.name
      }else {
        this.thumbnailName = '';
      }
    },
    clearUploadedPDfFileMethod(){
      let field = document.getElementById('pdfFile');
      field.value = null
      this.$refs.pdfFile = null
      this.pdfFile = null
      this.pdfFileName = ''
      this.$validator.reset();
    },
    handlePDfFileUploadMethod(event) {
      if(event.target.files && event.target.files.length > 0) {
        this.pdfFile = event.target.files[0];
        const files = this.$refs.pdfFile.files[0];
        this.pdfFileName = files.name
      }else {
        this.pdfFileName = '';
      }
    },
  },
  watch:{
  }
}